import { render, staticRenderFns } from "./TeleMarketThirdTaskConfig.vue?vue&type=template&id=0b3f8dc5&scoped=true"
import script from "./TeleMarketThirdTaskConfig.vue?vue&type=script&lang=js"
export * from "./TeleMarketThirdTaskConfig.vue?vue&type=script&lang=js"
import style0 from "./TeleMarketThirdTaskConfig.vue?vue&type=style&index=0&id=0b3f8dc5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3f8dc5",
  null
  
)

export default component.exports